import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api` 
  : 'http://localhost:8001/api';

export const useWebsiteSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/cms/website-settings`);
        setSettings(response.data);
        
        // Update favicon dynamically
        if (response.data.favicon_url) {
          const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
          favicon.type = 'image/x-icon';
          favicon.rel = 'shortcut icon';
          favicon.href = response.data.favicon_url;
          document.getElementsByTagName('head')[0].appendChild(favicon);
        }
        
        // Update page title if available
        if (response.data.site_name) {
          document.title = response.data.site_name;
        }
      } catch (error) {
        console.error('Failed to fetch website settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};
